import _regeneratorRuntime from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import ChatManagerInstance from "./ChatManager";
import BaseSessionAsync from "./BaseSessionAsync";
import FirebaseConversationSessionAsync from "./FirebaseConversationSessionAsync";
import * as log from "loglevel";

var ConversationSessionAsync = /*#__PURE__*/function (_BaseSessionAsync) {
  _inherits(ConversationSessionAsync, _BaseSessionAsync);

  function ConversationSessionAsync(userName, conversationName, accessToken) {
    var _this;

    _classCallCheck(this, ConversationSessionAsync);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ConversationSessionAsync).call(this, userName, accessToken));
    _this.conversationName = conversationName.toLowerCase();
    _this.audioFile = null;
    _this.resourceName = null;
    return _this;
  }

  _createClass(ConversationSessionAsync, [{
    key: "getAPIRequestFirebaseAccessURL",
    value: function getAPIRequestFirebaseAccessURL() {
      return ChatManagerInstance.restApiURL + "/conversations/" + this.conversationName + "/access?username=" + this.userName;
    }
  }, {
    key: "buildFirebaseSession",
    value: function buildFirebaseSession() {
      return new FirebaseConversationSessionAsync(this.userName, this.conversationName, this._id);
    }
  }, {
    key: "getAPIConversationsURL",
    value: function getAPIConversationsURL() {
      return ChatManagerInstance.restApiURL + "/conversations/" + this.conversationName;
    }
  }, {
    key: "getAPIMessagesURL",
    value: function getAPIMessagesURL() {
      return ChatManagerInstance.restApiURL + "/conversations/" + this.conversationName + "/messages";
    }
  }, {
    key: "getApiResourceURL",
    value: function getApiResourceURL() {
      return ChatManagerInstance.restApiURL + "/conversations/" + this.conversationName + "/resources";
    }
  }, {
    key: "writeMessage",
    value: function () {
      var _writeMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(message) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.doAPIRequest(this.getAPIMessagesURL(), "POST", {
                  message: message,
                  type: "TEXT"
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function writeMessage(_x) {
        return _writeMessage.apply(this, arguments);
      }

      return writeMessage;
    }()
  }, {
    key: "writeCustomMessage",
    value: function () {
      var _writeCustomMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(details, message) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.doAPIRequest(this.getAPIMessagesURL(), "POST", {
                  message: message,
                  type: "CUSTOM",
                  details: details
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function writeCustomMessage(_x2, _x3) {
        return _writeCustomMessage.apply(this, arguments);
      }

      return writeCustomMessage;
    }()
  }, {
    key: "editMessage",
    value: function () {
      var _editMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(messageId, message, callback) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.doAPIRequest(this.getAPIMessagesURL() + "/" + messageId, "PUT", {
                  message: message,
                  denyIfCensoredWords: false
                }, callback);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function editMessage(_x4, _x5, _x6) {
        return _editMessage.apply(this, arguments);
      }

      return editMessage;
    }()
  }, {
    key: "deleteMessage",
    value: function () {
      var _deleteMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(messageId, callback) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.doAPIRequest(this.getAPIMessagesURL() + "/" + messageId, "DELETE", {}, callback);

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function deleteMessage(_x7, _x8) {
        return _deleteMessage.apply(this, arguments);
      }

      return deleteMessage;
    }()
  }, {
    key: "updateCustomField",
    value: function () {
      var _updateCustomField = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(object, updateCustomFieldHandler) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.doAPIRequest(this.getAPIConversationsURL(), "PATCH", {
                  custom: object
                }, updateCustomFieldHandler);

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function updateCustomField(_x9, _x10) {
        return _updateCustomField.apply(this, arguments);
      }

      return updateCustomField;
    }()
  }, {
    key: "createResourceEntry",
    value: function () {
      var _createResourceEntry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(audioFile, formatValue, createResourceEntryHandler) {
        var response;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return this.doAxiosRequest(this.getApiResourceURL(), "POST", {
                  format: formatValue
                });

              case 3:
                response = _context6.sent;
                this.resourceName = response.data.name;
                _context6.next = 7;
                return this.uploadResourceRequest(response.data.temporaryUrl, "PUT", audioFile);

              case 7:
                _context6.next = 9;
                return this.doAxiosRequest(this.getApiResourceURL() + "/" + this.resourceName, "PUT", {
                  "status": "UPLOADED"
                });

              case 9:
                createResourceEntryHandler(null, {
                  "resource": this.resourceName,
                  "status": "UPLOADED"
                });
                _context6.next = 15;
                break;

              case 12:
                _context6.prev = 12;
                _context6.t0 = _context6["catch"](0);
                createResourceEntryHandler(_context6.t0);

              case 15:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 12]]);
      }));

      function createResourceEntry(_x11, _x12, _x13) {
        return _createResourceEntry.apply(this, arguments);
      }

      return createResourceEntry;
    }()
  }, {
    key: "writeResourceMessage",
    value: function () {
      var _writeResourceMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(resource, message, writeResourceMessageHandler, type) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.doAPIRequest(this.getAPIMessagesURL(), "POST", {
                  resource: resource,
                  message: message,
                  type: type
                }, writeResourceMessageHandler);

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function writeResourceMessage(_x14, _x15, _x16, _x17) {
        return _writeResourceMessage.apply(this, arguments);
      }

      return writeResourceMessage;
    }()
  }, {
    key: "getResourceDetails",
    value: function () {
      var _getResourceDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(resource, getResourceDetailsHandler, abortSignal) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.doGETRequest(this.getApiResourceURL() + "/" + resource, getResourceDetailsHandler, abortSignal);

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getResourceDetails(_x18, _x19, _x20) {
        return _getResourceDetails.apply(this, arguments);
      }

      return getResourceDetails;
    }()
  }, {
    key: "getAPILastReadTimestampURL",
    value: function getAPILastReadTimestampURL() {
      return ChatManagerInstance.restApiURL + "/conversations/" + this.conversationName + "/members/" + this.userName + "/lastReadTimestamp";
    }
  }, {
    key: "updateLastReadTimestamp",
    value: function () {
      var _updateLastReadTimestamp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(timestamp, updateLastReadTimestampHandler) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.doAPIRequest(this.getAPILastReadTimestampURL(), "PUT", {
                  timestamp: timestamp
                }, updateLastReadTimestampHandler);

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function updateLastReadTimestamp(_x21, _x22) {
        return _updateLastReadTimestamp.apply(this, arguments);
      }

      return updateLastReadTimestamp;
    }()
  }, {
    key: "getAPINextMessagesURL",
    value: function getAPINextMessagesURL(timestamp, page, size) {
      return this.getAPIMessagesHistoryURL("NEXT", timestamp, page, size);
    }
  }, {
    key: "getAPIAroundMessagesURL",
    value: function getAPIAroundMessagesURL(timestamp, beforeSize, afterSize) {
      var url = ChatManagerInstance.restApiURL + "/conversations/" + this.conversationName;
      url += "/aroundMessages?beforeSize=" + beforeSize + "&afterSize=" + afterSize + "&timestamp=" + timestamp;
      return url;
    }
  }, {
    key: "getAPIMessagesHistoryURL",
    value: function getAPIMessagesHistoryURL(type, timestamp, page, size) {
      var url = ChatManagerInstance.restApiURL + "/conversations/" + this.conversationName;

      if (type === "NEXT") {
        url += "/nextMessages?";
      } else if (type === "PREVIOUS") {
        url += "/previousMessages?";
      }

      if (timestamp !== void 0) {
        url += "timestamp=" + timestamp + "&";
      }

      if (page !== void 0) {
        url += "page=" + page + "&";
      }

      if (size !== void 0) {
        url += "size=" + size + "&";
      }

      return url;
    }
  }, {
    key: "getAroundMessages",
    value: function () {
      var _getAroundMessages = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(timestamp, beforeSize, afterSize, aroundMessagesHandler, abortSignal) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.doGETRequest(this.getAPIAroundMessagesURL(timestamp, beforeSize, afterSize), aroundMessagesHandler, abortSignal);

              case 2:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getAroundMessages(_x23, _x24, _x25, _x26, _x27) {
        return _getAroundMessages.apply(this, arguments);
      }

      return getAroundMessages;
    }()
  }, {
    key: "getNextMessages",
    value: function () {
      var _getNextMessages = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(timestamp, page, size, nextMessagesHandler) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.doGETRequest(this.getAPINextMessagesURL(timestamp, page, size), nextMessagesHandler);

              case 2:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function getNextMessages(_x28, _x29, _x30, _x31) {
        return _getNextMessages.apply(this, arguments);
      }

      return getNextMessages;
    }()
  }, {
    key: "getAPIPreviousMessagesURL",
    value: function getAPIPreviousMessagesURL(timestamp, page, size) {
      return this.getAPIMessagesHistoryURL("PREVIOUS", timestamp, page, size);
    }
  }, {
    key: "getPreviousMessages",
    value: function () {
      var _getPreviousMessages = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(timestamp, page, size, previousMessagesHandler) {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.doGETRequest(this.getAPIPreviousMessagesURL(timestamp, page, size), previousMessagesHandler);

              case 2:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getPreviousMessages(_x32, _x33, _x34, _x35) {
        return _getPreviousMessages.apply(this, arguments);
      }

      return getPreviousMessages;
    }()
  }, {
    key: "setConversationListener",
    value: function setConversationListener(externalConversationEventsListener) {
      log.trace("attach external Conversationlistener");

      if (this.firebaseSession) {
        this.firebaseSession.attachConversationListener(function (conversationEvent) {
          log.trace("conversation event" + JSON.stringify(conversationEvent));
          externalConversationEventsListener(conversationEvent);
        });
      }
    }
  }, {
    key: "leaveConversation",
    value: function leaveConversation() {
      this.firebaseSession.detachListener();
    }
  }]);

  return ConversationSessionAsync;
}(BaseSessionAsync);

export { ConversationSessionAsync as default };